import React from 'react';
import { CircularProgress, MenuItem, TextField } from '@material-ui/core';

interface IProps {
  data: Array<any> | null;
  selectedValue: any | null;
  setSelectedValue: (value: any) => void;
  loading?: boolean;
  label: string;
  error?: boolean;
  helperText?: string;
  variant?: 'filled' | 'outlined' | 'standard';
  renderItemText?: (item: any) => string;
}

const SelectField: React.FC<IProps> = ({
  data,
  selectedValue,
  setSelectedValue,
  loading = false,
  label,
  error = false,
  helperText,
  variant = 'outlined',
  renderItemText,
}) => (
  <TextField
    select
    margin='normal'
    label={label}
    value={selectedValue || ''}
    onChange={e => setSelectedValue(e.target.value)}
    name='parent'
    variant={variant}
    disabled={loading || !data}
    error={error}
    helperText={helperText}
    InputProps={{
      endAdornment: loading ? (
        <div
          style={{
            backgroundColor: 'white',
            zIndex: 10,
            marginRight: -4.5,
            marginTop: -1,
          }}
        >
          <CircularProgress size={15} />
        </div>
      ) : null,
    }}
  >
    {data?.map((item, index) => (
      <MenuItem key={item?.id || index.toString()} value={item?.id || ''}>
        {renderItemText ? renderItemText(item) : item.name}
      </MenuItem>
    ))}
  </TextField>
);

export default SelectField;
